import { useRef, useState } from "react";

import { FILTERS } from "../../utils/constants";
import Input from "../Input/Input";
import MultipleTagInput from "../MultipleTagInput/MultipleTagInput";
import MultiSelectStyled from "../MultiSelectStyled/MultiSelectStyled";
import { SearchBar } from "../Payment/FilterStyles";
import { SearchButton } from "../SearchButtons/SearchButtons";

export const INITIAL_FILTERS = {
  consignee: "",
  volantesForRequest: [],
  status: [],
};

export function AuthFilters({ onQuery }) {
  const [filters, updateFilters] = useState<any>(INITIAL_FILTERS);
  const multiTagRef = useRef();

  const updateVolantesForRequest = (newVolante) => {
    updateFilters((filters) => ({
      ...filters,
      volantesForRequest: newVolante,
    }));
  };

  const onConsigneeChange = (ev) =>
    updateFilters((filters) => ({ ...filters, consignee: ev.target.value }));
  const onStatusChange = (ev) =>
    updateFilters((filters) => ({ ...filters, status: ev.target.value }));

  return (
    <SearchBar hmargin={true} flexStart={true}>
      <div className="box">
        <h3>RUC Facturable:</h3>
        <Input
          width="40rem"
          type="text"
          placeholder="HP INC PERÚ"
          value={filters.consignee}
          onChange={onConsigneeChange}
        />
      </div>
      <div className="box">
        <h3>Número de Volante:</h3>
        <MultipleTagInput
          ref={multiTagRef}
          width="30rem"
          tagList={filters.volantesForRequest}
          onTagListUpdate={updateVolantesForRequest}
        />
      </div>
      <div className="box">
        <h3>Estado:</h3>
        <MultiSelectStyled
          height="4.5rem"
          width="40rem"
          selectItems={FILTERS.VALIDATION_THIRD.STATUS}
          info={filters.status}
          onInfoChange={onStatusChange}
        />
      </div>
      <div className="search-button--container box">
        <SearchButton onClick={() => onQuery(filters)} showfullName={true} />
      </div>
    </SearchBar>
  );
}

export function formatFilters(filters: any) {
  const status =
    filters.status.length > 0
      ? filters.status.map((e) => e.toLowerCase())
      : FILTERS.VALIDATION_THIRD.STATUS.map((e) => e.value.toLowerCase());
  const params = {
    third_party_billing_authorization_status_option: status,
    third_party_name: filters.consignee,
    volante_nums: filters.volantesForRequest,
  };
  Object.entries(params).forEach(([key, val]) => {
    if (!val) {
      delete params[key];
    }
  });
  return params;
}
